'use client';

import React from 'react';
import ContentfulGeneric from '@/features/contentful/ContentfulGeneric/ContentfulGeneric';
import ContentLayout from '@/layouts/ContentLayout';
import {
    TypeHeroComponentWithoutUnresolvableLinksResponse,
    TypeSimplePageLayoutWithoutUnresolvableLinksResponse,
} from '../_generated';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { HeroBannerWrapper } from '../ContentfulGeneric/ComponentWrappers';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import { TListItem } from '@/types/types';

type TStaticPageProps = {
    pageData: TypeSimplePageLayoutWithoutUnresolvableLinksResponse;
};

const StaticPageContent = ({
    livePageData,
}: {
    livePageData: TypeSimplePageLayoutWithoutUnresolvableLinksResponse;
}) => {
    return (
        <>
            {livePageData?.fields?.breadcrumbs?.length !== 0 && (
                <Breadcrumbs
                    id={livePageData?.sys?.id}
                    items={livePageData?.fields?.breadcrumbs as TListItem[]}
                />
            )}
            {livePageData?.fields?.heroComponent && (
                <HeroBannerWrapper
                    key={livePageData?.fields?.heroComponent?.sys?.id}
                    component={
                        livePageData?.fields
                            ?.heroComponent as TypeHeroComponentWithoutUnresolvableLinksResponse
                    }
                />
            )}
            <ContentfulGeneric mainBody={livePageData?.fields.mainBody} />
        </>
    );
};

const StaticPage = ({ pageData }: TStaticPageProps) => {
    const livePageData = useContentfulLiveUpdates(pageData);

    if (pageData.fields.spacing === 'Full Width (100%)')
        return <StaticPageContent livePageData={livePageData} />;

    return (
        <ContentLayout>
            <div className="simple-page-layout tw-mx-auto tw-w-full tw-text-[14px] lg:tw-text-[16px] lg:tw-w-[70%] tw-mb-[40px] lg:tw-mb-[80px] tw-mt-[20px] lg:tw-mt-[50px]">
                <StaticPageContent livePageData={livePageData} />
            </div>
        </ContentLayout>
    );
};

export default StaticPage;
